import React, { useCallback, useState } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import errorHandler from '../../../../../../components/error/ErrorHandler';

export default function PlantObligationTagsIconList(props) {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  // > TOGGLE TAG
  const toggleTag = useCallback(
    async (potID) => {
      setIsLoading(potID);
      axios
        .post(
          axiosPath(
            "api_r_user_module_legalCompliance_evaluation_plantObligationTag_toggle"
          ),
          { moduleBridgeHex, plantHex, plantObligationID, potID }
        )
        .then((r) => {
          setIsLoading(undefined);
          dispatch(
            currentPageAction.change("plantObligationLevels", {
              level3: {
                ...poLevel3,
                [plantObligationID]: {
                  ...poLevel3?.[plantObligationID],
                  alerts: {
                    ...poLevel3?.[plantObligationID].alerts,
                    plantObligationTags: r.data,
                  },
                },
              },
            })
          );
        })
        .catch((e) => {
          setIsLoading(undefined);
          dispatch(errorHandler(e));
        });
    },
    [plantObligationID, moduleBridgeHex, plantHex, poLevel3]
  );
  // < TOGGLE TAG

  return poLevel3?.[
    plantObligationID
  ]?.alerts?.plantObligationTags?.map((pot) => (
    <AppRemixIcon
      key={pot.id}
      icon={isLoading && pot.id === isLoading ? 'loader-4' : pot.icon}
      title={pot.name}
      color={pot.color}
      filled={pot.filled}
      className={pot.hasPermission ? 'pointer' : ''}
      onClick={
        pot.id !== isLoading && pot.hasPermission
          ? () => toggleTag(pot.id)
          : () => {}
      }
    />
  ));
}
